import React, { useState } from "react";
import { Upload, Button, Typography, App, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import PageHeader from "../../components/PageHeader";
import { fetchFileName } from "../helpers";

const { Title, Paragraph } = Typography;

const Image2Pdf = () => {
  const { message } = App.useApp();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const isModule = window.location.pathname.includes("/dashboard/");

  const props = {
    name: "files",
    multiple: true,
    accept: ".jpg,.jpeg,.png,.bmp,.tiff,.gif",
    beforeUpload: (file) => {
      setFileList((prevList) => [...prevList, file]);
      return false;
    },
    onRemove: (file) => {
      setFileList((prevList) => prevList.filter((f) => f.uid !== file.uid));
    },
    fileList,
  };

  const handleConvert = async () => {
    if (fileList.length === 0) {
      message.error("Please select at least one image file.");
      return;
    }

    const formData = new FormData();

    // ✅ Add "Source" exactly as in curl
    formData.append("Source", "Website");

    // ✅ Add each selected image file
    fileList.forEach((file) => {
      formData.append("files", file);
    });

    try {
      setUploading(true);
      setDownloadUrl("");
      let response = { data: {} };

      if (isModule) {
        const authToken = localStorage.getItem("token") || "";
        response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/Pdf/image-to-pdf`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/WebsitePdf/website-image-to-pdf`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      // ✅ Handle successful response
      if (response.data && !response.data.error && response.data.data) {
        const url = response.data.data.s3Url || "";
        setDownloadUrl(url);
        message.success(
          response.data.message || "Images converted successfully!"
        );
      } else {
        message.error(response.data.message || "Unknown error occurred.");
      }
    } catch (error) {
      console.error(error);
      message.error("Conversion failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      {isModule ? <PageHeader /> : <HeaderLayout />}

      <div className="converter-container">
        <Typography className="text-center">
          <Title level={3}>
            Convert <b>Images</b> to <b>PDF</b>
          </Title>
          <Paragraph>
            Upload multiple JPG, PNG, or other image files and combine them into
            a single PDF file.
          </Paragraph>
        </Typography>

        <div className="upload-box">
          <Upload.Dragger {...props}>
            <Button icon={<UploadOutlined />} className="choose-files-button">
              CHOOSE IMAGES
            </Button>
            <p style={{ marginTop: 12 }}>or drop images here</p>
          </Upload.Dragger>
        </div>

        <Space style={{ marginTop: 16 }}>
          <Button
            type="primary"
            className="convert-btn"
            onClick={handleConvert}
            loading={uploading}
          >
            Convert to PDF
          </Button>

          {!!downloadUrl && (
            <Button
              download={fetchFileName(downloadUrl)}
              href={downloadUrl}
              target="_blank"
              type="primary"
              className="convert-btn"
            >
              Download PDF
            </Button>
          )}
        </Space>
      </div>

      {!isModule && <FooterLayout />}
    </>
  );
};

export default Image2Pdf;
